import { withStyles } from '@material-ui/core/styles';

import {
  Typography,
  ExpansionPanel,
  ExpansionPanelSummary,
  ExpansionPanelDetails
} from '@material-ui/core';

export const FaqExpansionPanel = withStyles({
  root: {
    border: 'none',
    boxShadow: 'none',
    '&:not(:last-child)': {
      borderBottom: 0,
    },
    '&:before': {
      display: 'none',
    },
    '&$expanded': {
      margin: 'auto',
    },
  },
  expanded: {},
})(ExpansionPanel);

export const FaqExpansionPanelSummary = withStyles({
  root: {
    position: 'relative',
    backgroundColor: 'rgba(0, 0, 0, 0)',
    borderBottom: 'none',
    marginBottom: -1,
    paddingLeft: '36px',
    minHeight: 56,
    '&$expanded': {
      minHeight: 56,
    },
    '&:before': {
      content: "'+'",
      fontSize: '1.6rem',
      fontWeight: 500,
      position: 'absolute',
      left: 0,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      bottom: '3px',
      height: '100%',
      width: '1rem',
    },
    '&$expanded:before': {
      content: "'–'"
    },
  },
  content: {
    '&$expanded': {
      margin: '12px 0',
    },
  },
  expanded: {},
})(ExpansionPanelSummary);

export const FaqExpansionPanelDetails = withStyles(theme => ({
  root: {
    paddingLeft: '36px',
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
  },
}))(ExpansionPanelDetails);

export const FaqMainTitle = withStyles(theme => ({
  root: {
    color: theme.palette.text.light,
    marginBottom: '20px',
    fontSize: '32px',
    fontWeight: 'bold',
    letterSpacing: '-0.48px',
  }
}))(Typography);

export const QuestionTitle = withStyles(() => ({
  root: {
    fontSize: '18px',
    letterSpacing: '-0.27px',
  }
}))(Typography);

export const AnswerParagraph = withStyles(theme => ({
  root: {
    color: theme.palette.text.light,
    fontSize: '18px',
    letterSpacing: '-0.4px',
    lineHeight: '27px',
    '& p:first-of-type': {
      marginTop: 0,
    }
  },
}))(Typography);